import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from './../../../private/shared/modules/shared.module';

import { TranslateModule } from '@ngx-translate/core';
import { ModuleSharedModule } from '../../modules/module-shared.module';
import { PromoSummaryModalPage } from './promo-summary-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
    ModuleSharedModule
  ],
  declarations: [
    PromoSummaryModalPage
  ],
  exports: [
    PromoSummaryModalPage
  ]
})
export class PromoSummaryModalPageModule { }
